<!--MobileApply:移动端申请试用 2021/12/23 13:42:39 YuAng-->

<template>
  <iframe class="ho-mobile-apply" :src="url" width="100%" frameborder="0"></iframe>
</template>
<script>
export default {
  name: 'MobileApply',
  data() {
    return {
      url: ''
    }
  },
  created() {
    this.url = process.env.VUE_APP_URL_BEIKE + '/index.html#/apply/mobile'
  }
}
</script>

<style scoped>
.ho-mobile-page {
  background: white;
}
.ho-mobile-apply {
  height: calc(100% - 4px);
  background: white;
}
</style>